import { useEffect, useState } from "react";
import { getClientDomain, getToken, translate,  } from "../../../../utils/Common";
import ignoreAbort from '../../../../utils/ignoreAbort';

const InfoClient = ({ idCliente, handleMethodsChosen, methodsChosen }) => {
    const [infoCliente, setInfoCliente] = useState(null);

    const getFullName = () => {
        return `${ infoCliente.Nombre ? infoCliente.Nombre?.toString() : '' } ${ infoCliente.Apellidos ? infoCliente.Apellidos?.toString() : '' }`
    }

    useEffect(() => {
        const controller = new AbortController();
        try {
            const getInfo = async () => {
                const response = await fetch(`${getClientDomain()}/clients/searchSpecific/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({ buscarCliente: idCliente })
                });

                const result = await response.json();
                if (result.code === 200) {
                    if (result.payload) {
                        setInfoCliente(result.payload[0]);
                        let validate = methodsChosen?.map(m => m.id === 5 && true).shift()
                        if (!validate) Number(result.payload[0].SaldoCliente) > 0 && handleMethodsChosen([...methodsChosen, { id: 5, name: 'ABONO CLIENTE', amount: Number(result.payload[0].SaldoCliente) }])
                    }
                    else setInfoCliente({ NombreCliente: '', Saldo: 0 });
                }
                else {
                    setInfoCliente({ NombreCliente: '', Saldo: 0 });
                }
            }

            getInfo().catch(ignoreAbort);
        } catch (err) {
            console.log(err);
            setInfoCliente([ { NombreCliente: '', Saldo: 0 }]);
        }
        return () => controller.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="mt-2 mb-2 mx-3">
            <div className="flex flex-wrap -mx-2 mx-0 mb-1 border-bottom">
                <h6 className="ml-2 my-1">{translate("global.customerInformation")}</h6> 
            </div>
            
            <div className="flex flex-wrap -mx-2 mx-0">
                <div className="w-7/12 pb-0 mb-0" >
                    <label className="mb-0" htmlFor="inputNombreCliente">{translate("global.name")}:</label>
                    <input type="text" value={ infoCliente ? getFullName() : '' } id="inputNombreCliente" readOnly className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm font-semibold"/>
                </div>

                <div className="w-5/12 pb-0 mb-0" >
                    <label className="mb-0" htmlFor="inputSaldo">{translate("dashboard.platforms.details.cashBalance")}:</label>
                    <input type="text" value={ infoCliente ? `$ ${infoCliente.SaldoCliente}` : '$ 0.00' } id="inputSaldo" readOnly className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm font-semibold"/>
                </div>
            </div>
        </div>
    );
}

export default InfoClient;